import { render, staticRenderFns } from "./DialogInfoService.vue?vue&type=template&id=064aaba8&"
import script from "./DialogInfoService.vue?vue&type=script&lang=js&"
export * from "./DialogInfoService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports